import { Copy } from 'lucide-react';
import { panoyaKopyala } from '@/lib/pano';

/**
 * Küçük "kopyala" düğmesi — personel kartındaki IBAN düğmesiyle aynı görünüm.
 * Değer boşsa çizilmez: işlevsiz bir düğme "kopyalanacak bir şey var" dedirtir.
 * `deger` panoya gidecek metin; ekranda görünenden farklı olabilir (IBAN'ın
 * boşluksuz hâli gibi).
 */
export default function KopyalaDugmesi({ deger, etiket, testId }) {
  if (!deger) return null;
  return (
    <button type="button"
      onClick={(e) => { e.stopPropagation(); panoyaKopyala(deger, `${etiket} kopyalandı`); }}
      title={`${etiket} kopyala`} aria-label={`${etiket} kopyala`}
      className="flex-shrink-0 inline-flex items-center justify-center w-6 h-6 rounded-md
                 text-[#8a7e70] hover:text-[#2e6fa0] hover:bg-[#2e6fa0]/10 transition-colors"
      data-testid={testId || `kopyala-${etiket}`}>
      <Copy size={12} />
    </button>
  );
}
